import { PDFDocument, StandardFonts, rgb } from 'pdf-lib';

/** Append centered grey footer text on every page (consultancy / org watermark). */
export async function stampPdfFooterWatermark(pdfBlob: Blob, line: string): Promise<Blob> {
  const trimmed = line.trim();
  if (!trimmed) return pdfBlob;

  const bytes = await pdfBlob.arrayBuffer();
  const doc = await PDFDocument.load(bytes, { ignoreEncryption: true });
  const font = await doc.embedFont(StandardFonts.Helvetica);
  const size = 8;
  const color = rgb(0.42, 0.42, 0.42);

  for (const page of doc.getPages()) {
    const { width } = page.getSize();
    const textWidth = font.widthOfTextAtSize(trimmed, size);
    const x = Math.max(24, (width - textWidth) / 2);
    page.drawText(trimmed, {
      x,
      y: 14,
      size,
      font,
      color,
    });
  }

  const out = await doc.save();
  return new Blob([out], { type: 'application/pdf' });
}
